import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import {List} from 'material-ui/List';
import PatientData from '../../offers/components/PatientData';

var Config = require('../../../config');

class ModalInfo extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			donation: {},
			donor_person:{},
			offers: {},
			group_test: {},
			offer_id: "",
			patient: {},
			patient_person:{},

			day_sessions:[],
			national_centers: [],
			convoke_places:[],
			extraction_types: [],
			donation_types:[],
			blood_bags: [],
			biometrics:[],
			apheresis:[],

			component_kit:[],
			asigned_kit:[],
			unit:[],
			social_number:""
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		this.getServices();
	}

	getServices(){
		fetch(Config.default.apiGateway.URL+'donation_type_extraction',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', "Tipos Extracción: "+result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      extraction_types: response
		    });
		});

		fetch(Config.default.apiGateway.URL+'work_sessions/'+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      day_sessions: response
		    });
		});

		this.convokePlace();
		this.getBloodBags();
		this.getApheresisKit();
	}

	handleShow(id){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'donations/get_external_donation?id='+id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		}).then(res => {
			this.props.waiting.handleClose();
	    	if(res.ok){
	          	return res.json();
	        }else{
	          	res.text().then(function(result) {
	            	swal('¡Error', result, 'error');
	          	});
        	}
        	
        }).then(response => {
			if(response !== undefined){

				this.setState({
					show: true,
					donation: response.donation,
					offers: response.offers,
					donor_person: response.donor_person,
					group_test: response.group_test,
					patient: response.patient,
					patient_person: response.patient_person,
					unit: response.unit
				});

				this.getBiometricts(response.donor_person.sex);

				setTimeout(()=>{
					response.biometrics.map((b)=>{
						if(document.getElementById('biometric_'+b.biometrics_id) !== null){
							document.getElementById('biometric_'+b.biometrics_id).value = b.value
						}
					});

					response.vital_signs.map((vs)=>{
						if(document.getElementById('vital_sign_'+vs.biometrics_id) !== null){
							document.getElementById('vital_sign_'+vs.biometrics_id).value = vs.value
						}
					})
				}, 500)
					
				

				this.getDonationType(response.offers.donation_type_extraction_id);

				if(response.patient !== null){
					this.setState({
						relationship:response.offers.patient_relationship,
						national_center_id:response.offers.national_center_id,
						national_name:response.offers.patient_section_name,

					});

					var item = {
						patient: response.patient,
						person: response.patient_person
					};

					this.setInfoPatient(item);
				}

				this.state.apheresis.map(function(a){
					if(a.apheresis_kit.id === response.donation.apheresis_kits_id){
						this.setState({
							component_kit:a.asigned_components.components,
							asigned_kit: a.asigned_components.asigned,
						});
					}
				}.bind(this));

				setTimeout(function(){
					this.state.component_kit.map(function(c, i){

						var objIndex = this.state.unit.findIndex((obj => obj.blood_component_id === this.state.asigned_kit[i].blood_component_id));
					
						if(objIndex === -1){
							this.setState({
								unit: [...this.state.unit, 
										[{
											unit:1,
											donation_id:this.state.donation_id,
											blood_component_id:this.state.asigned_kit[i].blood_component_id, 
											volume:"", 
											current_unit:true,
											unit_number:this.state.donation_number,
											component_number: "",
											//caducidad: this.calculateExpiration(this.state.asigned_kit[i].expiration_days)
									  	},
									  	{
									  		unit:2,
											donation_id:this.state.donation_id,
											blood_component_id:this.state.asigned_kit[i].blood_component_id, 
											volume:"", 
											current_unit:true,
											unit_number:this.state.donation_number,
											component_number: "",
											//caducidad: this.calculateExpiration(this.state.asigned_kit[i].expiration_days)
									  	}]
									  ]
							});
						}	
					}.bind(this));
				}.bind(this), 500);
					
			}

		})
	}

	handleClose(){
		this.setState({
			show: false,
			/*
			donation: {},
			donor_person:{},
			offers: {},
			group_test: {},
			offer_id: "",
			patient: {},
			patient_person:{},

			day_sessions:[],
			national_centers: [],
			extraction_types: [],
			donation_types:[],
			blood_bags: [],
			biometrics:[],
			sv:[],
			apheresis:[],

			component_kit:[],
			asigned_kit:[],
			unit:[],*/
		});
	}

	convokePlace(){
		fetch(Config.default.apiGateway.URL+'convoke_places?option=no_operatives&health_facilities_id='+
			sessionStorage.getItem('health_facilities_id'),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			if(response !== undefined){
				this.setState({convoke_places: response});
			}

			
		})
	}

	getDonationType(id){
		fetch(Config.default.apiGateway.URL+'donation_rules?option=donation_extraction&donation_extraction_id='+id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({ donation_types: response});		    
		});
	}

	getBloodBags(){
		//blood_bags
		fetch(Config.default.apiGateway.URL+'blood_bags/by_hf/'+sessionStorage.getItem('health_facilities_id'), {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'	 	: 'application/json',
				'Content-Type' 	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({
				blood_bags: response
			})
		})
	}

	getBiometricts (sex){
		fetch(Config.default.apiGateway.URL+'biometrics?option=biometrics_for_entry&sex='+sex,{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
	    })
	    .then(response => response.json())
	    .then(response => {
	      for (var i = 0; i < response.length; i++) {
	      	response[i].offer_id = this.state.offer_id;
	      };
	      this.setState({biometrics: response});
	      
	    })
	}

	selectFieldHandle = (id, name, event, index, value) => {
		this.setState({[event.target.name]:event.target.value});
	}

	setInfoPatient(item){
		if(item !== "" && item !== undefined)
		{
			this.setState({
				patient_name:item.person.names,
				patient_lastname1:item.person.lastname1,
				patient_lastname2:item.person.lastname2,
				patient_id:item.patient.id,
		    	person_patient_id:item.person.id,
		    	social_number:item.person.social_number
			});

			//if (item.patient.relationship) {
				//this.setState({relationship:item.patient.relationship});
			//};

			//if (item.patient.observations) {
				this.setState({observations:item.patient.observations});
			//};

			//if (item.patient.national_name) {
				//this.setState({national_name:item.patient.national_name});
			//};

			//if (item.patient.number) {
				this.setState({no_file:item.patient.number});
			//};
			if (item.person.lookup_group && item.person.lookup_rh) {
				this.setState({
					lookup_group:item.person.lookup_group,
				    lookup_rh:item.person.lookup_rh
				});

				if (this.state.lookup_rh === "POSITIVO") {
					this.setState({
						rh_group: item.person.lookup_group +' +',
					});
				}else {
					this.setState({
						rh_group: item.person.lookup_group +' -',
					});
				};
			}else{
				this.setState({
					rh_group: "",
				});
			}

			//ver si es national center
			if (item.patient.national_center_id) {
				this.setState({hemored:false});

				this.setState({national_center_id:item.patient.national_center_id});

			} else{//hemored
				this.setState({hemored:true});

				if (item.patient.facility_section_id) {
					this.setState({facility_section_id:item.patient.facility_section_id});

					this.offer.searchHealthFacility(item.patient.facility_section_id);
				};
			};

			this.patient.setState({disablePatient:true});
		}
	}

	getApheresisKit(){
		//apheresis_kits
		fetch(Config.default.apiGateway.URL+'apheresis_kits',{
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept' 		: 'application/json',
				'Content-Type'	: 'application/json', 
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({
				apheresis: response
			})
		})
	}

	render(){
		const {t} = this.props;
		return (
			<Modal  dialogClassName="modal-view" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<fieldset className="col-xs-12">
		        			<legend>Datos del Donante</legend>
			        		<div className="col-xs-12">
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Fecha Registro</span>
			        				<input type="text" disabled className="form-control" 
			        					value={
			        						(moment(this.state.donation.timestamp_date, 'YYYY-MM-DD').format('DD/MM/YYYY')+' '+
			        						moment(this.state.donation.timestamp_hour, 'HH:mm').format('HH:mm')) || ""
			        					} />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Sesion</span>
			        				<select disabled className="form-control" value={this.state.offers.work_session_id || ""}>
				        				{this.state.day_sessions.map(function(t) {
						                	return <option  key={t.id}  value={t.id} >{t.type_value} </option>;
						                })}
					            	</select>
			        			</div>
			        			<div className="col-xs-12 col-sm-4">
			        				<span className="span-min">Centro Colecta</span>
			        				<select disabled className="form-control input_data_donor" value={ this.state.offers.convoke_places_id || "" } >
						              	<option value="">Seleccionar...</option>
						                {this.state.convoke_places.map(function(t, i) {
						                  return <option key={i}  value={t.convoke_places.id} >
						                  	{t.convoke_places.name} 
						                  </option>;
						                })}
					              	</select>
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Tipo Extracción</span>
			        				<select disabled className="form-control input_data_donor" value={ this.state.offers.donation_type_extraction_id || ""} >
						              	<option value="" disabled>Seleccionar...</option>
						                {this.state.extraction_types.map(function(t) {
						                	return <option key={t.donation_type_extraction.id} value={t.donation_type_extraction.id} >{t.lookup_value}</option>;
						                })}
						            </select>
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Tipo Donación</span>
			        				<select disabled className="form-control input_data_donor" value={ this.state.offers.donation_type_id || ""} >
							        	<option value="" disabled >Seleccionar...</option>
						                {this.state.donation_types.map(function(t) {
						                	return <option key={t.donation_type.id} value={t.donation_type.id} >{t.donation_type_lookup}</option>;
						                })}
						            </select>
			        			</div>
			        		</div>
			        		<div className="col-xs-12">
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Nombre(s)</span>
			        				<input type="text" disabled className="form-control" value={this.state.donor_person.names || ""} />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Apellido Paterno</span>
			        				<input type="text" disabled className="form-control" value={this.state.donor_person.lastname1 || ""} />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Apellido Materno</span>
			        				<input type="text" disabled className="form-control" value={this.state.donor_person.lastname2 || ""} />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Fecha Nacimiento</span>
			        				<input type="text" disabled className="form-control"
			        					value={moment(this.state.donor_person.birthday, 'YYYY-MM-DD').format('DD/MM/YYYY')} />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Edad</span>
			        				<input type="text" disabled className="form-control" value={this.state.offers.donor_age || ""} />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
			        				<span className="span-min">Sexo</span>
			        				<input type="text" disabled className="form-control" value={this.state.donor_person.sex || ""} />
			        			</div>
			        		</div>
			        	</fieldset>

			        	{this.state.patient !== null?
							
							<div style={{padding:"5px"}}>
								<PatientData setState={this.setState} 
				        		validate={this.validateInput}
								state={this.state} 
								onRef={ref => (this.patient = ref)}
								handleChange={this.handleChange} 
								selectFieldHandle={this.selectFieldHandle} 
								setInfoPatient={this.setInfoPatient}
								setInfoDonor={this.setInfoDonor}
								autocompleteHandle={this.autocompleteHandle}
								clearPatientSearch = {this.clearPatientSearch}/>
							</div>
						:null}


			        	<fieldset className="col-xs-12">
			        		<legend>Datos Donacion</legend>
			        		<div className="col-xs-12">
			        			<div className="col-xs-12 col-sm-2">
		        					<span className="span-min">No. Donacion</span>
			        				<input type="text" disabled className="form-control" value={this.state.donation.donation_number || ""} />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
		        					<span className="span-min">Fecha Extracción</span>
			        				<input type="text" disabled className="form-control" 
			        				value={moment(this.state.donation.timestamp_date, 'YYYY-MM-DD').format('DD/MM/YYYY')} />
			        			</div>
			        			<div className="col-xs-12 col-sm-2" style={{marginTop: "20px"}}>
			        				<input type="text" disabled className="form-control" value={moment(this.state.donation.timestamp_hour, 'HH:mm').format('HH:mm') || ""} />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
		        					<span className="span-min">No. Externo</span>
			        				<input type="text" disabled className="form-control" value={this.state.donation.local_number || ""} />
			        			</div>
			        			<div className="col-xs-12 col-sm-2">
		        					<span className="span-min">Fecha y Hora Registro</span>
			        				<input type="text" disabled className="form-control" value={
			        						(moment(this.state.donation.timestamp_date, 'YYYY-MM-DD').format('DD/MM/YYYY')+' '+
			        						moment(this.state.donation.timestamp_hour, 'HH:mm').format('HH:mm')) || ""
			        					}  />
			        			</div>
			        		</div>


			        		{this.state.offers.donation_type_extraction_id !== undefined ?
			        			this.state.offers.donation_type_extraction_id === 1 ?
			           				<div className="col-xs-12">
					        			<div className="col-xs-12 col-sm-2">
				        					<span className="span-min">Tipo Bolsa</span>
					        				<select disabled className="form-control bio_extraction" value={ this.state.donation.blood_bags_id || ""}>
												<option value="" disabled>Seleccionar...</option>
												{this.state.blood_bags.map(function(t) {
													return <option key={t.blood_bag.id} value={t.blood_bag.id} >{t.blood_bag.name}</option>;
												})}
											</select>
					        			</div>
					        			<div className="col-xs-12 col-sm-2">
				        					<span className="span-min">Duración (min)</span>
					        				<input type="text" disabled className="form-control" value={this.state.donation.extraction_time || ""} />
					        			</div>
					        			<div className="col-xs-12 col-sm-2">
				        					<span className="span-min">Volumen (ml)</span>
					        				<input type="text" disabled className="form-control" value={this.state.donation.volume || ""} />
					        			</div>
					        			<div className="col-xs-12 col-sm-2">
				        					<span className="span-min">Grupo y RH</span>
					        				<input type="text" disabled className="form-control" value={
					        					this.state.group_test !== null ?
					        						this.state.group_test.group + ' '+
					        						(this.state.group_test.RH === 'POSITIVO' ?
					        							'+' :
					        						this.state.group_test.RH === 'NEGATIVO' ?
					        							'-' 
					        						: '')
					        					: ""
					        				} />
					        			</div>
					        		</div>
					        	: <div className="col-xs-12" style={{padding:"0px"}}>

									<div className="col-xs-12" style={{padding:"0px"}}>
										<div className="col-xs-12 col-sm-2">
								        	<span className="span-min">{t('content.extractions.apheresis.apheresis_kits_id')}</span>
											<select disabled className="form-control bio_extraction" 
												value={this.state.donation.apheresis_kits_id !== undefined ? this.state.donation.apheresis_kits_id : ""}>
								              	<option value="" disabled>Seleccionar...</option>
								                {this.state.apheresis.map(function(t){
							                		return <option key={t.apheresis_kit.id} value={t.apheresis_kit.id} >{t.apheresis_kit.name}</option>;
							                	})}
								            </select>
								        </div>
								        <div className="col-xs-12 col-sm-2" style={{padding:"0px"}}>
											<span className="span-min">Grupo y RH</span>
											<input type="text" disabled className="form-control" value={
					        					this.state.group_test !== null ?
					        						this.state.group_test.group + ' '+
					        						(this.state.group_test.RH === 'POSITIVO' ?
					        							'+' :
					        						this.state.group_test.RH === 'NEGATIVO' ?
					        							'-' 
					        						: '')
					        					: ""
					        				} />
										</div>
								    </div>

								    <div className="col-xs-12" style={{padding:"0px"}}>
								    	<div className="col-sm-6">
								    		<div className="col-xs-12 col-sm-6">
								    		
									    	</div>
									    	{this.state.donation.apheresis_kits_id!==""?
									    		<div className="col-xs-12 col-sm-3" style={{textAlign:"center"}}>
										    		<span className="span-min">Bolsa 1</span>
										    	</div>
										    :null}
									    	{this.state.donation.double ?
									    		<div className="col-xs-12 col-sm-3" style={{textAlign:"center"}} >
										    		<span className="span-min">Bolsa 2</span>						    		
										    	</div>
										    :null
									    	}
										    	
								    	</div>
								    </div>

								    <div className="col-xs-12" style={{padding:"0px"}}>
								    	<div className="col-sm-6 form-group">
								        	{this.state.component_kit.length > 0 ?
								        		this.state.component_kit.map(function(c, i){        	
										        	return (
										        		<div className="col-xs-12 " key={c.id}>
											        		<div className="col-xs-6" style={{padding:"5px 0 0 0"}}>
											        			<span className="span-min">{c.component}</span>
											        		</div>
											        		{this.state.unit[i] !== undefined ?
											        			<div className="col-xs-3" style={{padding:"5px 0 0 12px"}}> 
									        						<input id={'vol_'+this.state.asigned_kit[i].blood_component_id+'_'+this.state.unit[i].unit}  
									        							disabled className="form-control volume-unit bio_extraction" type="number"
																		name={'vol_'+this.state.asigned_kit[i].blood_component_id+'_'+this.state.unit[i].unit}
																		value={this.state.unit[i].volume || ""} //onKeyPress={(e) => this.props.validate(e)}
																		 />
									        					</div>
									        				:null}
								        						
											        													        		
											        	</div>
											        )			
								        		}.bind(this))
								        		: null
								    		}
								        </div>
								    </div>
								</div>
					        :null}
			        	</fieldset>

			        	<fieldset className="col-xs-12">
			        		<legend>Biometría Hemática</legend>
			        		<div className="col-xs-12">
			        			<List>
		        				{this.state.biometrics.map( (t, index) => (
									<div className="col-xs-12 col-sm-3 col-md-1" style={{padding:"2px 2px 2px 8px",overflow:"hidden"}} key={index}>
										<span className="size-min" style={{whiteSpace:"nowrap"}}>{t.name}</span>
									
										<input disabled className="form-control bio_extraction" 
											name={'biometric_'+t.id.toString()} maxLength="4"
											id={'biometric_'+t.id.toString()} />
									</div>
								))}
			        			</List>
			        		</div>
			        	</fieldset>				        
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>

		)
	}

} 

export default translate('translations') (ModalInfo);